import styled from 'styled-components';
import { Column } from 'components/shared/Layout';

export const StyledColumn = styled(Column)`
  padding: 16px;
`;
